export default function mailPermissionAnsweringPersons(patientAge, permissionBothParentsRequired) {
    const answeringPersons = [];

    if (patientAge === null) {
        return answeringPersons;
    }

    if (patientAge > 11) {
        answeringPersons.push('patient');
    }

    if (patientAge < 16) {
        answeringPersons.push('parent_1');

        if (permissionBothParentsRequired) {
            answeringPersons.push('parent_2');
        }
    }

    return answeringPersons;
}

export function mailPermissionAnsweringPersonLabelKey(answeringPerson, permissionBothParentsRequired) {
    if (answeringPerson === 'parent_1' && !permissionBothParentsRequired) {
        return 'patient.fields.answer_parent';
    }

    return `patient.fields.answer_${answeringPerson}`;
}
